/* Meshki-style product media gallery (mobile).
   The slider itself is native CSS scroll-snap (see meshki-gallery.css) - all
   this script does is:
   1) let desktop-mouse/trackpad users drag-to-scroll it (touch already
      scrolls natively, no JS needed for that), and
   2) keep the thin progress line under the gallery in sync with scroll
      position.
   Only runs below the 768px breakpoint where the CSS slider is active. */
(function () {
  function initGallery(scroller) {
    if (scroller.meshkiInit) return;
    scroller.meshkiInit = true;

    var mediaGroup = scroller.closest('[data-product-single-media-group]');
    var progressBar = mediaGroup && mediaGroup.querySelector('.t4s-meshki-progress__bar');

    var ticking = false;
    function updateProgress() {
      ticking = false;
      if (!progressBar) return;
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var pct = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
      pct = Math.max(0, Math.min(1, pct));
      progressBar.style.transform = 'scaleX(' + pct + ')';
    }
    function requestProgressUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateProgress);
    }

    scroller.addEventListener('scroll', requestProgressUpdate, { passive: true });
    window.addEventListener('resize', requestProgressUpdate);
    updateProgress();

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    function onPointerDown(e) {
      if (window.matchMedia('(min-width: 768px)').matches) return;
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScroll = scroller.scrollLeft;
      scroller.classList.add('is--dragging');
    }
    function onPointerMove(e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) moved = true;
      scroller.scrollLeft = startScroll - dx;
    }
    function onPointerUp() {
      if (!isDown) return;
      isDown = false;
      scroller.classList.remove('is--dragging');
    }

    scroller.addEventListener('mousedown', onPointerDown);
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);

    // Suppress the click on a slide that was actually a drag (e.g. opening
    // the lightbox) so dragging doesn't accidentally trigger it.
    scroller.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function init() {
    document
      .querySelectorAll('.t4s-product-media__meshki_grid .t4s-meshki-grid')
      .forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
